import { NavLink } from "react-router-dom";

export const SubBar = ({ pages }) => {
  return pages?.map((page, index) => (
    <NavLink key={index} className="p-1" to={page.path}>
      {page.label}
    </NavLink>
  ));
};
